/**
 * getToken's rejection once silent renewal needs the user back at the sign-in
 * page (msal InteractionRequiredAuthError, e.g. AADSTS160021 when Safari or
 * Firefox block the renewal iframe's cookies). Kept import-free so telemetry
 * and utils can recognise it without pulling in the store.
 */
export class SessionExpiredError extends Error {
  constructor(cause?: unknown) {
    super('Your sign-in expired. Sign in again to continue.', { cause })
    this.name = 'SessionExpiredError'
  }
}
